var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.conversation)?_c('div',{staticClass:"message-box"},_vm._l((_vm.messages),function(item){return _c('Message',{key:item._id,attrs:{"message":item}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }